import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailListValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || !Array.isArray(control.value)) {
      return null;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails: string[] = control.value;

    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      return {
        emailList: {
          value: control.value,
          invalidEmails: invalidEmails,
        },
      };
    }

    return null;
  };
}
